import { service } from ".";

export default {
  getAll: () => service.get("/resumes"),
  getOne: (id) => service.get(`/resumes/${id}`),
  getAllPaginate: (query) => service.get(`/resumes/paginate?${query}`),
  create: (data) => service.post("/resumes", data),
  update: (id, data) => service.put(`/resumes/${id}`, data),
  achive: (id) => service.put(`/resumes/arxiv/${id}`),
  delete: (id) => service.delete(`/resumes/${id}`),
};
